import { render, staticRenderFns } from "./BirthdayInput.vue?vue&type=template&id=b57b6fa0"
import script from "./BirthdayInput.vue?vue&type=script&lang=js"
export * from "./BirthdayInput.vue?vue&type=script&lang=js"
import style0 from "./BirthdayInput.vue?vue&type=style&index=0&id=b57b6fa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports